import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueries, EXTERNAL_URL } from "@/services";
import { transformErrorResponse, transformSuccessResponse } from "@/services";

const { rawExternalApiBaseQuery: locationBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.sregService,
});

export const locationApi = createApi({
    reducerPath: 'locationApi',
    baseQuery: locationBaseQuery,
    endpoints: (builder) => ({
        getLocationDropdowns: builder.query({
            query: ({ stateCode, districtCode, subDistrictCode, pincode } = {}) => ({
                url: 'location',
                method: 'GET',
                params: { stateCode, districtCode, subDistrictCode, pincode },
            }),
            transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),

    }),
});

export const {
    useGetLocationDropdownsQuery,
    useLazyGetLocationDropdownsQuery
} = locationApi;

export default locationApi;
